var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Password_icon",
    "data-name": "Password icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.176,
    height: 26.645,
    viewBox: "0 0 33.176 26.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password_icon-2",
    "data-name": "Password icon",
    transform: "translate(0 15.409) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6852",
    "data-name": "Path 6852",
    d: "M18.834,3.1l-1.342-1.35a.833.833,0,0,0-.55-.186.807.807,0,0,0-.36.111.96.96,0,0,0-.415.546l.027,1.47H2.156L0,5.137v.519l2.75,2.75H4.416L5.8,7.3,7.523,9.1,8.9,9.142l1.548-1.41,1.883,1.83,1.606-1.306h2.03c-.024.5-.051,1.009-.075,1.516a1.054,1.054,0,0,0,.116.56.816.816,0,0,0,.4.4.721.721,0,0,0,.688-.106l1.47-1.074A6.818,6.818,0,0,0,20.1,11.4a6.489,6.489,0,0,0,7.62.62,6.486,6.486,0,0,0,.468-10.751A6.552,6.552,0,0,0,25.338.079,6.487,6.487,0,0,0,22.4.293,6.717,6.717,0,0,0,18.834,3.1ZM27.32,4.523a2.011,2.011,0,1,1-2.4,1.531A2.012,2.012,0,0,1,27.32,4.523Z",
    transform: "translate(0)",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordicon);
export default __webpack_public_path__ + "static/media/Password icon.4f77c9c039b62da1619578e2e6d4b622.svg";
export { ForwardRef as ReactComponent };